import getXcolumnJson from "./xcolumn/list";
import StudyArea from "./study";
import strFunc from "@/lib/lyg/string";

function SectionArea(props: any) {
  const myProps = {
    rowData: {},
    section_info: {},
    section_row_num: 0,
    section_arr: [],
    study_arr: [],
    set_section_arr: (section_arr: any) => { },
    ...props
  };

  const studyXColumnArr = getXcolumnJson();
  const default_row_data = {
    "a_book_seq": "",
    "a_seq": "1",
    "a_section_seq": "",
    "a_title": "",
    "a_content": "",
    "a_amount_sort": "",
    "a_amount_num": "",
    "a_page_start_num": "",
    "a_par_id": "",
    "a_par_seq": "",
    "a_add_file_type": "image",//video,audio
    "a_order_num": "",
  };
  let study_arr = myProps.study_arr;
  let section_arr = myProps.section_arr;
  let procedure_key_arr = ["a_add_file_type"];
  let study_key_arr = ["a_page_start_num"];
  let coolen_key_arr = ["a_par_id", "a_par_seq"];
  for (let i = 0; i < studyXColumnArr.x_column_list_arr.length; i++) {
    let tmp_column = studyXColumnArr.x_column_list_arr[i];
    if (myProps.rowData["a_use_sort"] == "procedure") {
      if (strFunc.str_in_array(tmp_column["key"], procedure_key_arr) != -1) {
        studyXColumnArr.x_column_list_arr[i]["is_show"] = "1";
      }
    }

    if (myProps.rowData["a_use_sort"] == "study") {
      if (strFunc.str_in_array(tmp_column["key"], study_key_arr) != -1) {
        studyXColumnArr.x_column_list_arr[i]["is_show"] = "1";
      }
    }

    if (myProps.rowData["a_use_sort"] == "coolen") {
      if (strFunc.str_in_array(tmp_column["key"], coolen_key_arr) != -1) {
        studyXColumnArr.x_column_list_arr[i]["is_show"] = "1";
      }
    }
  }

  const get_study_tags = () => {
    let study_tags: any = "";
    if (myProps.section_info.study_arr) {
      study_tags = myProps.section_info.study_arr.map((item: any, idx: number) => {
        return (
          <StudyArea
            key={idx}
            rowData={myProps.rowData}
            study_info={item}
            study_idx={idx}
            studyXColumnArr={studyXColumnArr}
            section_arr={myProps.section_arr}
            study_arr={myProps.study_arr}
          ></StudyArea>
        );
      });
    }

    if (strFunc.is_empty(study_tags)) {
      study_tags = (
        <tr>
          <td colSpan={99}>
            <div className="text-center" style={{ lineHeight: "40px" }}>
              내용이 없습니다.
            </div>
          </td>
        </tr>
      );
    }

    return study_tags;
  };

  return (
    <div className="mt-5" >
      <div className="text-left">
        <span>
          {myProps.section_row_num + 1}.
        </span>
        <span>
          {myProps.section_info.a_title}
        </span>
      </div>

      <div className="list-table-div mt-1" style={{ width: "99%", marginLeft: "1%" }} >
        <table>
          <thead>
            <tr>
              {
                studyXColumnArr.x_column_list_arr.map((column: any, idx: number) => {
                  if (column["is_show"] != "1") {
                    return "";
                  }
                  let column_str: any = column["name"];
                  return (
                    <th key={idx}>
                      <div style={{ width: parseInt(column["width"]) }}>
                        {column_str}
                      </div>
                    </th>
                  );
                })
              }
            </tr>
          </thead>
          <tbody>
            {get_study_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default SectionArea;